// Side effect
import './shaders/bilateral_blur.fragment.js';
import { radians } from '../Math.js';
import { PostProcessShader, ShaderDescription, ShaderDescriptorType } from './utility/PostProcessShader.js';
export class BilateralBlur {
    constructor(radius, scene, enable_normal_filtering) {
        this.depth_threshold = 0.02;
        this.normal_angle_threshold = radians(30.0);
        this._enable_normal_filtering = enable_normal_filtering;
        const defines = [];
        defines.push('#define RADIUS ' + radius.toFixed(1));
        if (this._enable_normal_filtering) {
            defines.push('#define ENABLE_NORMAL_FILTERING');
        }
        const desc = new ShaderDescription('bilateral_blur');
        this._descriptors = {
            depth_threshold: desc.add_descriptor(ShaderDescriptorType.FLOAT, 'depthThreshold'),
            normal_cosine_threshold: desc.add_descriptor(ShaderDescriptorType.FLOAT, 'normalCosineThreshold'),
            direction: desc.add_descriptor(ShaderDescriptorType.VEC2, 'direction'),
            texture_sampler: desc.add_descriptor(ShaderDescriptorType.SAMPLER_2D, 'textureSampler'),
            depth_sampler: desc.add_descriptor(ShaderDescriptorType.SAMPLER_2D, 'depthSampler'),
            normal_sampler: desc.add_descriptor(ShaderDescriptorType.SAMPLER_2D, 'normalSampler')
        };
        this._shader = new PostProcessShader(scene, desc, defines);
    }
    render(scene, source, source_depth, source_normals, intermediate, destination) {
        this.render_separated_internal(scene, source, source_depth, source_normals, intermediate, { x: 1, y: 0 });
        this.render_separated_internal(scene, intermediate, source_depth, source_normals, destination, { x: 0, y: 1 });
    }
    render_separated_internal(event_data, source, source_depth, source_normals, destination, direction) {
        if (this._enable_normal_filtering && !source_normals) {
            console.error('Bilateral blur with normal filtering enabled was not given a normal sampler.');
            return;
        }
        else if (!this._enable_normal_filtering && source_normals) {
            console.warn("Normal sampler was given to bilateral filter, but it's unused. Did you mean to enable normal filtering on the Bilateral blur?");
        }
        this._shader.set_descriptor(this._descriptors.depth_threshold, this.depth_threshold);
        this._shader.set_descriptor(this._descriptors.normal_cosine_threshold, Math.cos(this.normal_angle_threshold));
        this._shader.set_descriptor(this._descriptors.direction, direction);
        this._shader.set_descriptor(this._descriptors.texture_sampler, source);
        this._shader.set_descriptor(this._descriptors.depth_sampler, source_depth);
        this._shader.set_descriptor(this._descriptors.normal_sampler, source_normals);
        this._shader.render(destination);
    }
    dispose() {
        this._shader.dispose();
    }
}
//# sourceMappingURL=BilateralBlur.js.map